import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import DemoNote from "@/components/DemoNote";
import { TechLabel } from "@/components/Bits";
import usePageMeta from "@/hooks/usePageMeta";
import { COMPANY } from "@/config/company";

const LEGAL_ROWS = [
  ["Ragione sociale", COMPANY.legal.ragioneSociale],
  ["Sede legale", COMPANY.legal.sede],
  ["Partita IVA", COMPANY.legal.piva],
  ["Codice fiscale", COMPANY.legal.cf],
  ["REA", COMPANY.legal.rea],
];

export default function InfoLegal() {
  usePageMeta(
    "Informazioni legali — MMC S.r.l.",
    "Dati societari, privacy policy e cookie policy di MMC S.r.l., azienda di carpenteria metallica."
  );

  return (
    <main>
      <PageHeader
        index="07"
        eyebrow="Trasparenza"
        title="Informazioni legali"
        sub="Dati societari, informativa sul trattamento dei dati personali e policy sui cookie."
      />

      <section data-testid="legal-main" className="px-5 py-16 md:px-10 md:py-24 lg:px-16">
        <div className="mx-auto max-w-5xl">
          {/* DATI SOCIETARI */}
          <Reveal>
            <TechLabel className="text-molten">Dati societari</TechLabel>
            <dl className="mt-6 border-t border-white/10">
              {LEGAL_ROWS.map(([k, v]) => (
                <div
                  key={k}
                  data-testid={`legal-row-${k.toLowerCase().replace(/\s+/g, "-")}`}
                  className="grid grid-cols-1 gap-1 border-b border-white/10 py-4 sm:grid-cols-12 sm:items-baseline"
                >
                  <dt className="font-tech text-[10px] uppercase tracking-[0.25em] text-white/40 sm:col-span-4">{k}</dt>
                  <dd className="text-base text-white/85 sm:col-span-8">{v}</dd>
                </div>
              ))}
            </dl>
            <DemoNote className="mt-6" />
          </Reveal>

          {/* PRIVACY */}
          <Reveal delay={0.05}>
            <div data-testid="legal-privacy" className="mt-16">
              <h2 className="font-display text-3xl font-semibold uppercase tracking-tight">Privacy policy</h2>
              <div className="mt-6 max-w-3xl space-y-4 leading-relaxed text-fog">
                <p>
                  Ai sensi del Regolamento UE 2016/679 (GDPR), {COMPANY.legal.ragioneSociale} — in qualità di Titolare
                  del trattamento — tratta i dati personali che l'utente decide di comunicare spontaneamente tramite il
                  modulo di contatto presente sul sito (nome, recapiti, azienda e contenuto della richiesta).
                </p>
                <p>
                  <strong className="text-white/85">Finalità:</strong> i dati sono trattati esclusivamente per valutare
                  e dare seguito alla richiesta di preventivo o di contatto, nonché per gli obblighi di legge connessi.
                  <br />
                  <strong className="text-white/85">Base giuridica:</strong> l'esecuzione di misure precontrattuali su
                  richiesta dell'interessato e l'adempimento di obblighi legali.
                  <br />
                  <strong className="text-white/85">Conservazione:</strong> i dati sono conservati per il tempo
                  necessario a gestire la richiesta e, in caso di rapporti commerciali, per gli obblighi amministrativi
                  previsti dalla legge.
                  <br />
                  <strong className="text-white/85">Diritti dell'interessato:</strong> l'utente può esercitare in ogni
                  momento i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione di cui
                  agli artt. 15-22 del GDPR, scrivendo al Titolare agli indirizzi di contatto pubblicati nella pagina
                  Contatti.
                </p>
              </div>
            </div>
          </Reveal>

          {/* COOKIE */}
          <Reveal delay={0.1}>
            <div data-testid="legal-cookie" className="mt-14">
              <h2 className="font-display text-3xl font-semibold uppercase tracking-tight">Cookie policy</h2>
              <div className="mt-6 max-w-3xl space-y-4 leading-relaxed text-fog">
                <p>
                  Questo sito utilizza esclusivamente cookie tecnici, necessari al corretto funzionamento delle pagine e
                  alla sicurezza della navigazione. Non vengono installati cookie di profilazione o di tracciamento di
                  terze parti a fini pubblicitari.
                </p>
                <p>
                  Non è pertanto richiesto il consenso preventivo dell'utente per l'installazione di questi cookie. Il
                  blocco o la cancellazione dei cookie tecnici tramite le impostazioni del browser può compromettere il
                  funzionamento del sito.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
